export default function Pen({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill={color}
      className="bi bi-pen"
    >
      <path
        fill="#000D5B"
        d="M17.852 1.448 16.539.135a.464.464 0 0 0-.652 0l-.987.983-.326-.326a.461.461 0 0 0-.656 0l-12.47 12.47a.42.42 0 0 0-.107.186l-.004-.004-1.313 3.938a.459.459 0 0 0 .064.417c.087.12.227.192.378.195.051 0 .1-.008.147-.023l3.938-1.313-.004-.004a.462.462 0 0 0 .187-.107L15.557 5.712l.656.656-2.295 2.295a.467.467 0 0 0-.004.66.466.466 0 0 0 .66-.004L17.2 6.694a.46.46 0 0 0 0-.656l-.986-.983.986-.986a.46.46 0 0 0 0-.656l-.326-.326.982-.983a.464.464 0 0 0-.003-.656ZM1.977 14.446 3.54 16.01l-2.342.78.78-2.343Zm2.422 1.11-1.968-1.969L14.244 1.774l1.969 1.969L4.399 15.556ZM16.213 2.43l-.657-.656.657-.656.656.656-.656.656Z"
      />
    </svg>
  );
}

import * as React from "react";
